import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from '@material-ui/core';
import ICategory from "../../categories/ICategory";
import ISubCategory from "../../categories/ISubCategory";
import IMenuItemBody from "../../../../interfaces/IMenuItemBody";
import { newProductTemplate } from "../ItemsContainer";
import { setCategoryId, setFilterState, setSubcategoryId } from "../state/itemContainer.actions";
import { IProduct } from "../../../../interfaces/IProduct";
import { ProductListSearch } from "./ProductListSearch";
import { ProductListCreateButton } from "./ProductListCreateButton";
import { ProductListSearchItem } from "./ProductListSearchItem";
import FilterComponent from "../../../../yoello-lib/modules/components/filterComponent/FilterComponent";
import TabList from '../../../../yoello-lib/modules/components/UI/Tabs/TabList';
import useParseTabItems from '../useParseTabItems';
import { useStyles } from "../../../menu/products/categories/CategoriesListController"
import { AddToMenuController } from "../../../manageMenu/AddToMenuInBulk/AddToMenuController";
import { IMenuData } from "../../../manageMenu/types";
import { IReduxAppState } from "../../../../reducers";

const useStyles2 = makeStyles({
    subcategoryWrapper: {
        width: "calc(100vw - 360px)",
        display: "block",
        padding: "12px",
        '@media (max-width: 600px)': {
            width: "calc(100vw - 60px)"
        }
    }
})

interface IProductListControlsProps {
    subcategoryID: string;
    categoryID: string;
    dispatch: any;
    subcategories: ISubCategory[];
    selectedSubCategories: ISubCategory[];
    categories: ICategory[];
    productList: IProduct[];
    selectedProductList: IMenuItemBody[];
    onItemSelection: (product: IProduct) => void;
    isLoading: boolean;
    venueId: string;
    menuItemsNotInMenu: IMenuItemBody[];
    menuItems: IMenuItemBody[];
    manageMenuAPI: any;
    orphanedMenuItemsAPI: any;
    menusList: IMenuData[]
    filtersList: any[];
    updateMenusListAPI?: any;
}

export function ProductListControls({
    subcategoryID,
    categoryID,
    subcategories,
    selectedSubCategories,
    categories,
    dispatch,
    productList,
    onItemSelection,
    isLoading,
    venueId,
    menuItemsNotInMenu,
    manageMenuAPI,
    orphanedMenuItemsAPI,
    menuItems,
    menusList,
    filtersList,
    updateMenusListAPI
}: IProductListControlsProps) {
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const venueSettings = useSelector((state: IReduxAppState) => state.venue[selectedVenueId]?.venueSettings);

    const { parseCategoryItems, parseSubcategoryItems } = useParseTabItems();
    const classes = useStyles();
    const classes2 = useStyles2();
    const {
        categoryTabs,
        defaultCategoryTab,
    } = parseCategoryItems(categories, subcategories);

    const {
        subcategoryTabs,
        defaultSubcategoryTab,
    } = parseSubcategoryItems(subcategories, categoryID);

    function onSelectItem(product: IProduct | null) {
        onItemSelection(product || newProductTemplate);
    }
    function getLabel(product: IProduct) {
        return product.details.name_public;
    }
    function renderOption(product: IProduct) {
        return <ProductListSearchItem publicName={product.details.name_public}
            internalName={product.details.name_internal} />;
    }
    function setFilters(filterSubmitData: any) {
        dispatch(setFilterState(filterSubmitData));
    }
    return <div>

        <div className={classes.controls}>
            {venueSettings?.on_menu_setup && menuItemsNotInMenu?.length > 0 && <AddToMenuController updateMenusListAPI={updateMenusListAPI}  menusList={menusList} menuItemsNotInMenu={menuItemsNotInMenu} orphanedMenuItemsAPI={orphanedMenuItemsAPI} manageMenuAPI={manageMenuAPI} menuItems={menuItems} subcategories={subcategories} venueId={venueId} />}


            <ProductListSearch productList={productList}
                getOptionLabelFunction={getLabel} renderOptionFunction={renderOption} onItemSelection={onSelectItem} />

            <div className="filters" id="filters">
                <FilterComponent filtersList={filtersList} filterkey={`product-filter-${venueId}`}
                    setFilterState={setFilters}
                />
            </div>
            <ProductListCreateButton buttonKey="newProductButton" title={'menu.menuItems.create'} isLoading={isLoading}
                onClick={() => {
                    onItemSelection(newProductTemplate);
                }} />
            <div style={{
                flex: "1 0 100%"
            }}>
                {categoryTabs && categoryTabs.length > 0 &&
                    <TabList
                        level={'primary'}
                        tabs={categoryTabs}
                        defaultTab={defaultCategoryTab}
                        onChange={(value) => dispatch(setCategoryId(value))}
                        hideCount
                        selectedTab={categoryID}
                    />
                }
            </div>
            {subcategoryTabs && subcategoryTabs.length > 0 &&
                <div className={classes2.subcategoryWrapper} style={{ }}>
                    <TabList
                        level={'secondary'}
                        tabs={subcategoryTabs}
                        defaultTab={defaultSubcategoryTab}
                        onChange={(value) => dispatch(setSubcategoryId(value))}
                        selectedTab={subcategoryID}
                        hideCount
                    />
                </div>
            }

        </div>
    </div>;
}